import React from 'react';
import styled from 'styled-components';

interface BCorpIconProps {
  hoverText?: string;
}

const BCorpIcon: React.FC<BCorpIconProps> = ({ hoverText = 'BCorp Icon' }) => (
  <BCorpContainer>
    <BCorp title={hoverText} aria-label={hoverText}>
      B
    </BCorp>
  </BCorpContainer>
);
export default BCorpIcon;

const BCorpContainer = styled.div`
  padding: 0px 0px 0px;
`;

const BCorp = styled.div`
  font-family: 'Helvetica', 'Poppins', sans-serif;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #999;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  color: #999;
  width: 20px;
  height: 20px;
  line-height: 1;

  &:hover {
    color: #555;
    border-color: #555;
    cursor: pointer;
  }
`;
